"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dotSpacer = void 0;
/**
 * Mixin function to create a dot spacer node
 * @param Object Contains the values for the margin left and right properties
 * @returns A serialized css style for dot spaces to use in a styled component
 */
const dotSpacer = ({ marginLeft = 'initial', marginRight = 'initial' }) => `
  content: '';
  display: inline-block;
  vertical-align: middle;
  margin-left: ${marginLeft};
  margin-right: ${marginRight};
  margin-top: -2px; /* vertical-align renders visually slightly low */
  height: 4px;
  width: 4px;
  border-radius: 50%;
  background-color: currentColor;
`;
exports.dotSpacer = dotSpacer;
//# sourceMappingURL=dot-spacer.styles.js.map